import type { FC } from "react";

import { PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { StyledActiveAlertIcon, StyledCaption, StyledEmailAlertButton, StyledInactiveAlertIcon } from "./styles";

type EmailAlertButtonProps = {
    isPaused: boolean;
    onChange(): void;
};

const EmailAlertButton: FC<EmailAlertButtonProps> = ({ isPaused, onChange }) => {
    const tooltip = isPaused
        ? translate("si.my-list.email-alerts.tooltip.paused")
        : translate("si.my-list.email-alerts.tooltip.weekly");

    return (
        <PlainTooltip
            allowHover
            closeDelay={50}
            maxWidth={230}
            tooltipContent={tooltip}
        >
            <div>
                <StyledEmailAlertButton onClick={onChange}>
                    {isPaused ? (
                        <StyledInactiveAlertIcon
                            iconName="alerts_off"
                            size="xs"
                        />
                    ) : (
                        <StyledActiveAlertIcon
                            iconName="alerts"
                            size="xs"
                        />
                    )}
                    <StyledCaption>{isPaused ? "Paused" : "Weekly"}</StyledCaption>
                </StyledEmailAlertButton>
            </div>
        </PlainTooltip>
    );
};

export default EmailAlertButton;
